// extracted by mini-css-extract-plugin
module.exports = {"root":"TabNav_root__o_NOU","tab":"TabNav_tab__3viCH","link":"TabNav_link__ggo_u","selectedLink":"TabNav_selectedLink__2BI2C","disabled":"TabNav_disabled__3KQF1"};